<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="180px">
            <el-form-item label="设备编号：" prop="code">
                <span>{{model.code}}</span>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <span>{{model.alias}}</span>
            </el-form-item>
            <el-form-item label="借调前所在项目：" prop="alias">
                <span>{{project}}</span>
            </el-form-item>
            <el-form-item label="借调后所在项目：" prop="new_project_id">
                <el-select v-model="model.new_project_id" placeholder="请选择" clearable filterable style="width: 300px">
                    <el-option v-for="item in projectList" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById, saveModel } from '@/api/common'
import { deviceCheckBorrow } from '@/api/deviceuser'

export default {
    name: 'deviceCheckEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                model: '',
                time_difference: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                flow_threshold: 40,
                pressure_threshold: 3,
                lift_threshold: 100,
                work_time_type: '1',
                work_time_start: '',
                work_time_end: '',
                new_project_id: 0,
            },
            getObj:{
                url:'/api/admin/devicecheck/borrowInfo',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_state'],
            rules: {
                new_project_id: [
                    {required: true, message: '请选择借调后的项目', trigger: 'blur'},
                ],
            },
            checkObj:{
                url:'/api/admin/devicecheck/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
            project: {},
            projectList: [],
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    deviceCheckBorrow(this.id, this.model.new_project_id).then(res=>{
                        if(res.code===1){
                            this.$msgs("借调成功！");
                            this.$emit("on-close",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.deviceCheck;
                        this.project = res.data.old_project
                        this.projectList = res.data.projectList
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        formateData(){
            this.model.device_state = this.model.device_state+""
        },
    }
};
</script>